import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { useParams } from "react-router-dom"
import { RootState } from "@/core/app/store"
import Scans from "@/modules/Records/Scans/Scans2"
import { PhotosAndXRays } from "@/UDTreat/components/photos/PhotosAndXRaysForCreatingProcess"
import { setWidthAll,  setIsCreateSelfplanRefinement, setIsCreateNewRefinement, setStageShowType, setIsDoingPresetup, setCurLeftPage } from "@/UDTreat/udTreatSlice"
import CloseIcon from "@mui/icons-material/Close"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { closeAlert, setAlert } from "@/core/app/slices/alert/alertSlice"
import { UAlert, UButton, UText } from "@/components/index"
import { Box, Button, IconButton } from "@mui/material"
import { caseManagement, resourcesSynchronization, wasmModule, treatView} from "@/gluelayer"
import { uploadCaseZips } from "@/core/app/slices/clinical/clinicalThunkApi"
import { setUploadStls } from "../core/app/slices/records/scans/scansSlice"
import { setPhotoTypeJson } from "../core/app/slices/records/photograph/photographSlice"
import DialogBox from "@/modules/Clinical/components/DialogBox/dialogBox"
import { setRefinementReady } from "@/core/app/slices/clinical/clinicalSlice"
import { cancelRefine } from "@/gluelayer/core/modules/sagemaker/presetup"
import { setLoading } from "@/core/app/slices/clinical/clinicalSlice"
import JSZip from "jszip"
import { updateCaseById, caseConversionAction } from "@/core/app/slices/case/caseThunkApi"
import { CASE_ACTION } from "@/core/constants/caseActionType"

function getFileExtension(file: File) {
  const parts = file.name.split(".")
  const extension = parts[parts.length - 1].toLowerCase()
  return extension
}

export const CreateSelfplanRefinement = ({ requestRefinementPresetup, showJsPreview }) => {
  const { refinementNum, widthAll } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const { current_orgId } = useAppSelector(
    (state: RootState) => state.userService.user,
  )
  const dispatch = useAppDispatch()
  const { t } = useTranslation("common")
  const [step, setStep] = useState(0)
  const upperModelCache = useRef(null)
  const lowerModelCache = useRef(null)
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { uploadSTL } = useAppSelector((state) => state.scansService)
  const { patientId, caseId } = useParams()
  const [cancelWarning, setCancelWarning] = useState(false)
  const { alertMsg, isError, btnText, btnAction, timeout } = useAppSelector(
      (state: RootState) => state.alert,
    )

  const getCurrentStepComponent = () => {
    if (step === 0) {
      return <Scans isRefinement={true}/>
    } else if (step === 1) {
      return (
        <PhotosAndXRays
          isZoomoutAbled={true}
          isDragAbled={true}
          isDeleteAbled={true}
          refinementIndex={refinementNum}
        />
      )
    }
  }
 
  const changeToNextStep = async () => {
    dispatch(closeAlert())
    if (step === 0) {
      dispatch(setLoading("pending"))
      const udesignCategory = caseDetail?.udesign_category? caseDetail.udesign_category : `"A"/"A"`
      const arches = udesignCategory.split("/")
      const isupper = arches[0].includes("R") || arches[0].includes("A");
      const islower = arches[1].includes("R") || arches[1].includes("A");
      if (isupper && islower && !uploadSTL.upper && !uploadSTL.lower) {
        dispatch(
          setAlert({
            message: t("records.scans.noScanFile"),
            isError: true,
            horizontalPosition:"right",
          }),
        )
        dispatch(setLoading("complete"))
        return
      } else if (isupper && !uploadSTL.upper){
        dispatch(
          setAlert({
            message: t("records.scans.missUpperScan"),
            isError: true,
            horizontalPosition:"right",
          }),
        )
        dispatch(setLoading("complete"))
        return
      } else if (islower && !uploadSTL.lower){
        dispatch(
          setAlert({
            message: t("records.scans.missLowerScan"),
            isError: true,
            horizontalPosition:"right",
          }),
        )
        dispatch(setLoading("complete"))
        return
      }
      // check if need to save
      await new Promise(resolve => {
        setTimeout(async () => {
          if (upperModelCache.current == uploadSTL.upper && lowerModelCache.current == uploadSTL.lower) {
            resolve(true)
            return
          }
          const  zip = new JSZip()
          const data0Folder = zip.folder("Setting Data0")
          const rawFolder = zip.folder("Raw")
          const data2Folder = zip.folder("Setting Data2")
          if (upperModelCache.current !== uploadSTL.upper) {
            // needResetPresetup = true
            upperModelCache.current = uploadSTL.upper
              ? uploadSTL.upper
              : null
            resourcesSynchronization.deleteFile(
              "test/case/Setting Data10/refinement/arch_u.mtc",
            )

            // save to virtual memory
            const stlFile = upperModelCache.current
            const ext = getFileExtension(stlFile) 
            let isSaveOk = false;
            if (ext === "stl") {
              const stlFilePath: Record<string, any> = {}
              stlFilePath["test/pre/arch_u.stl"] = stlFile
              await resourcesSynchronization.moduleFS(stlFilePath)
              const isSaveU = wasmModule.module.SaveMtcFileToFolder(
                "test/pre/arch_u.stl",
                "Setting Data10/refinement/arch_u.mtc",
              )
              isSaveOk= isSaveU
            }else if (ext === 'mtc') {
              await resourcesSynchronization.saveFileToZip(stlFile,'refinement/arch_u.mtc','Setting Data10')
              isSaveOk = true
            }
            console.log("isSaveUpperMTC :",isSaveOk)
          }
          if (lowerModelCache.current !== uploadSTL.lower) {
            // needResetPresetup = true
            lowerModelCache.current = uploadSTL.lower
              ? uploadSTL.lower
              : null
            resourcesSynchronization.deleteFile(
              "test/case/Setting Data10/refinement/arch_l.mtc",
            )

            // save to virtual memory
            const stlFile = lowerModelCache.current
            const ext = getFileExtension(stlFile) 
            let isSaveOk = false;
            if (ext === "stl") {
              let stlFilePath: Record<string, any> = {}
              stlFilePath["test/pre/arch_l.stl"] = stlFile
              await resourcesSynchronization.moduleFS(stlFilePath)
              const isSaveU = wasmModule.module.SaveMtcFileToFolder(
                "test/pre/arch_l.stl",
                "Setting Data10/refinement/arch_l.mtc",
              )
              isSaveOk = isSaveU
            }else if (ext === 'mtc') {
              await resourcesSynchronization.saveFileToZip(stlFile,'refinement/arch_l.mtc','Setting Data10')
              isSaveOk = true
            }
            console.log("isSaveLowerMTC :",isSaveOk)
          }

          const mtcNames = [
            "/test/case/Setting Data10/refinement/arch_u.mtc",
            "/test/case/Setting Data10/refinement/arch_l.mtc",
          ]
          const mtcFiles = resourcesSynchronization.getFilesByPathname([
            mtcNames[0],
            mtcNames[1],
          ])

          if (mtcFiles.get("arch_u.mtc")) {
            data0Folder.file("arch_u.mtc", mtcFiles.get("arch_u.mtc"));
            rawFolder.file("arch_o_u.mtc", mtcFiles.get("arch_u.mtc"));
          }

          if (mtcFiles.get("arch_l.mtc")) {
            data0Folder.file("arch_l.mtc", mtcFiles.get("arch_l.mtc"));
            rawFolder.file("arch_o_l.mtc", mtcFiles.get("arch_l.mtc"));
          }
          let upArchType = 0,
            downArchType = 0
          const originArchTypeData = resourcesSynchronization.getFileDirectly(
            "ArchType.json",
            "Setting Data2",
            "utf8",
          )
          if (originArchTypeData) {
            const dataObject = JSON.parse(originArchTypeData)
            if (dataObject.hasOwnProperty("upArch")) {
              upArchType = dataObject.upArch
            }
            if (dataObject.hasOwnProperty("downArch")) {
              downArchType = dataObject.downArch
            }
          }
          const archType = {
            KeepPalate: false,
            downArch: downArchType,
            upArch: upArchType,
          }
          data2Folder.file("ArchType.json", JSON.stringify(archType))
          const content = await zip.generateAsync({
            type: "blob",
            compression: "DEFLATE",
            compressionOptions: { level: 6 },
          });
          // // for test: dowload the zip file
          // const link = document.createElement('a')
          // link.style.display = 'none'
          // document.body.appendChild(link)
          // const blob = new Blob([content], { type: 'application/zip' })
          // link.href = URL.createObjectURL(blob)
          // link.download = "NewScan.zip"
          // link.click()
          // document.body.removeChild(link)

          const zips = []
          zips.push({
            fileName: "NewScan.zip",
            file: content,
          })
          caseManagement.getCaseFiles(["bulk2", "bulk10"]).then((r) => {
            if (r) {
              for (const k in r) {
                zips.push({
                  fileName: k,
                  file: r[k],
                })
                // // for test: dowload the zip file
                // const link = document.createElement('a')
                // link.style.display = 'none'
                // document.body.appendChild(link)
                // const blob = new Blob([r[k]], { type: 'application/zip' })
                // link.href = URL.createObjectURL(blob)
                // link.download = k
                // link.click()
                // document.body.removeChild(link)
              }
              dispatch(
                uploadCaseZips({
                  zips,
                  patientId,
                  caseId,
                }),
              ).then(() => {
                resolve(true);
              })
            }
          })
          dispatch(setLoading("complete"))
        }, 100)
      })
      await dispatch(caseConversionAction({ patientId, caseId, payload: { action: CASE_ACTION.START_REFINE_PRESETUP}}))

      const newUdesignJsonObj = {
        ... JSON.parse(caseDetail.udesign_json),
        isDoingRefinePresetup: true,
      }
      await dispatch(
        updateCaseById({
          patientId,
          caseId,
          payload: {
            case_extra_attrs: JSON.stringify(newUdesignJsonObj),
          },
        }),
      )
      requestRefinementPresetup(
        uploadSTL.upper? true: false, 
        uploadSTL.lower? true: false, 
        JSON.parse(caseDetail.udesign_json))

      // setStep(step + 1)
      dispatch(setRefinementReady(false))
      showJsPreview()
      treatView.Open(false)
      if (widthAll) {
        dispatch(setWidthAll(false))
      }  
      dispatch(setIsDoingPresetup(true))
      dispatch(setStageShowType(""))

      // selfplanSubmit()
      dispatch(setIsCreateNewRefinement(false))
      dispatch(setIsCreateSelfplanRefinement(false))
    } 
    // else if (step === 1) {
    //   dispatch(setRefinementReady(false))
    //   showJsPreview()
    //   treatView.Open(false)
    //   if (widthAll) {
    //     dispatch(setWidthAll(false))
    //   }  
    //   dispatch(setIsDoingPresetup(true))
    //   dispatch(setStageShowType(""))

    //   selfplanSubmit()
    //   dispatch(setIsCreateNewRefinement(false))
    //   dispatch(setIsCreateSelfplanRefinement(false))
    // }
  }
  useEffect(() => {
    // setIsCancelRefine(false)
    dispatch(closeAlert())
    dispatch(setCurLeftPage(""))
    dispatch(
      setUploadStls({
        upper: null,
        lower: null,
      }),
    )
    dispatch(setPhotoTypeJson(null))
  }, [])
  return (
    <Box
      id="createselfplanrefinement"
      sx={{
        backgroundColor: "white",
        width: widthAll ? "100%" : "60%",
        height: "100%",
        position: "absolute",
        top: "0",
        right: "0",
        zIndex: "10",
        overflowY: "auto",
        paddingTop: "40px",
        paddingBottom: "40px",
      }}
    >
      <Button
        variant="contained"
        sx={{
          position: "absolute",
          left: 20,
          top: 20,
          display: widthAll ? "" : "none",
        }}
        onClick={async () => {
          await dispatch(setWidthAll(!widthAll))
          window.dispatchEvent(new Event("resize"))
        }}
      >
        {widthAll ? `Show Initial` : `View New Scans and PHotos`}
      </Button>
      <IconButton
        aria-label="close"
        onClick={() => {
          if(step === 0){
            treatView.Open(false)
            dispatch(setStageShowType("normal"))
            dispatch(setIsCreateNewRefinement(false))
            dispatch(setIsCreateSelfplanRefinement(false))
            if (widthAll) {
              dispatch(setWidthAll(false))
            }
          }else if(step === 1){
            setCancelWarning(true)
          }
        }}
        sx={{
          position: "absolute",
          right: 12,
          top: 10,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Box
        id="context-container"
        sx={{
          display: "flex",
          justifyContent: "center",
          minHeight: "400px",
        }}
      >
        {getCurrentStepComponent()}
      </Box>
      <Box
        id="navigator"
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          display: "flex",
          padding: "40px",
          justifyContent: step === 0 ? "flex-end" : "space-between",
        }}
      >
        {step !== 0 && (
          <Button
            variant={"outlined"}
            onClick={() => {
              setStep(step - 1 > -1 ? step - 1 : 0)
            }}
            sx={{ width: "92px", height: "36px" }}
          >
            <ChevronLeftIcon fontSize={"small"} sx={{ marginLeft: "3px" }} />
            {t("button.back")}
          </Button>
        )}
        <Button
          onClick={() => {
            changeToNextStep()
          }}
          variant="contained"
          sx={{
            right: "10px",
            width: "92px",
            height: "36px",
          }}
        >
          {step === 0? t("button.next") : t("button.submit")}
          <ChevronRightIcon sx={{ marginLeft: "3px" }} fontSize={"small"} />
        </Button>
      </Box>
      <DialogBox open={cancelWarning} title="Warning" content={<>{"Are you sure you want to exit the process?"}</>} actions=
      {<>
          <UButton
            onClickHandler={ () => {
              setCancelWarning(false)
            }}
            variant={"text"}
            btnText={("cancel")}
          />
          <UButton
            onClickHandler={ () => {
              // setIsCancelRefine(true)
              // cancelRefine()
              // handleCancel()
            }}
            variant={"text"}
            btnText={("Confirm")}
          />
        </>
      }
      >
      </DialogBox>
    </Box>
  )
}